import React from 'react';
import { MapPin, Smartphone, Bell, ShieldOff, Users, Headphones } from 'lucide-react';
import { pessoaFisicaFeatures, siteConfig } from '../data/mock';

const PessoaFisicaSection = () => {
  const whatsappLink = `https://wa.me/${siteConfig.phone}?text=${encodeURIComponent('Olá! Gostaria de conhecer os planos de rastreamento veicular pessoal.')}`;

  const iconMap = {
    MapPin,
    Smartphone,
    Bell,
    ShieldOff,
    Users,
    Headphones
  };

  return (
    <section id="pessoa-fisica" className="bg-[#0f1419] py-20">
      <div className="container mx-auto px-6 md:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-block bg-blue-600/20 border border-blue-500/30 rounded-full px-4 py-1.5 mb-6">
              <span className="text-blue-400 text-sm font-semibold uppercase tracking-wider">Pessoa Física</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
              Proteção Veicular Completa <br />
              <span className="text-blue-500">para Você e sua Família</span>
            </h2>
            <p className="text-lg sm:text-xl text-gray-400 max-w-3xl mx-auto">
              Tenha o controle total do seu veículo na palma da mão. O <strong className="text-white">rastreador veicular em Sorocaba</strong> mais completo para uso pessoal.
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {pessoaFisicaFeatures.map((feature, index) => {
              const Icon = iconMap[feature.icon];
              return (
                <div
                  key={index}
                  className="bg-gradient-to-br from-slate-900/80 to-slate-800/50 backdrop-blur-sm border border-blue-500/10 rounded-xl p-6 hover:border-blue-500/30 transition-all hover:shadow-lg hover:shadow-blue-500/10 group"
                >
                  <div className="w-14 h-14 bg-blue-600/20 rounded-xl flex items-center justify-center mb-4 group-hover:bg-blue-600/30 transition-colors">
                    <Icon className="w-7 h-7 text-blue-400" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
                  <p className="text-gray-400 leading-relaxed text-[15px]">{feature.description}</p>
                </div>
              );
            })}
          </div>

          {/* CTA */}
          <div className="text-center">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all shadow-lg hover:shadow-blue-600/50 hover:scale-105"
            >
              Conhecer Planos de Rastreamento
            </a>
            <p className="text-gray-400 text-sm mt-4">Atendimento rápido em Sorocaba e região</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PessoaFisicaSection;
